import { usePriority } from "@faire/retailer-visitor-shared/components/PriorityRenderer/PriorityStore";
import React, { useEffect, useId } from "react";

export const withPriority = <P extends object>(
  Component: React.ComponentType<P>,
  canRenderHook: (props: P) => boolean
) => {
  return function (props: P) {
    const id = useId();
    const { shouldRender, registerToRender } = usePriority(id);
    const canRender = canRenderHook(props);

    useEffect(() => {
      const unregsiter = registerToRender(canRender);
      return () => {
        unregsiter();
      };
    }, [canRender, registerToRender]);

    return shouldRender ? <Component {...props} /> : null;
  };
};
